import { combineReducers } from '@reduxjs/toolkit';
import { auditListReducer } from './reducers/audit-list-reducer';
import type { IAuditState } from './interfaces';

export default combineReducers<IAuditState>({
  auditListReducer,
});
